import { render, staticRenderFns } from "./AddNewFormDialog.vue?vue&type=template&id=c518ccfc&"
import script from "./AddNewFormDialog.vue?vue&type=script&lang=js&"
export * from "./AddNewFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports